import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'risk-login_modal_login_with_sso-click';

/**
 * /login-modal/login-with-sso
 */
export function trackRiskLoginModalLoginWithSsoClick(
  Provider_string: string = '',
  Source_id_string2: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    parameters: { Provider_string, Source_id_string2 },
  });
}
